<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="600px">
        <div class="row" v-loading="loading">
            <div class="col-6">
                <x-select v-model="form.attribute_4000.value"
                          :options="countries"
                          :label="form.attribute_4000.name"
                          filterable></x-select>
            </div>
            <div class="col-6">
                <x-select v-model="form.attribute_4001.value"
                          :options="countries"
                          :label="form.attribute_4001.name"
                          filterable></x-select>
            </div>
            <div class="col-12">
                <x-input v-model="form.attribute_4007.value"
                         :label="form.attribute_4007.name"></x-input>
            </div>
            <div class="col-6">
                <x-select v-model="form.attribute_4008.value"
                          :options="identity_document_types"
                          :label="form.attribute_4008.name"
                          filterable></x-select>
            </div>
            <div class="col-6">
                <x-input v-model="form.attribute_4009.value"
                         :label="form.attribute_4009.name"></x-input>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label class="control-label">{{ form.attribute_4002.name }}</label>
                    <el-date-picker v-model="form.attribute_4002.value"
                                    :clearable="false"
                                    type="date"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label class="control-label">{{ form.attribute_4003.name }}</label>
                    <el-date-picker v-model="form.attribute_4003.value"
                                    :clearable="false"
                                    type="date"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label class="control-label">{{ form.attribute_4004.name }}</label>
                    <el-date-picker v-model="form.attribute_4004.value"
                                    :clearable="false"
                                    type="date"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                </div>
            </div>
            <div class="col-6">
                <x-input v-model="form.attribute_4005.value"
                         :label="form.attribute_4005.name"></x-input>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label class="control-label">{{ form.attribute_4006.name }}</label>
                    <el-date-picker v-model="form.attribute_4006.value"
                                    :clearable="false"
                                    type="date"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                </div>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                <x-button-submit @click="onSubmit"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../components/Form/XButtonCancel";
import XButtonSubmit from "../../../components/Form/XButtonSubmit";
import XModal from "../../../components/XModal";
import XInput from "../../../components/Form/XInput.vue";
import XButtonIcon from "../../../components/Form/XButtonIcon.vue";
import XSelect from "../../../components/Form/XSelect.vue";
import moment from "moment/moment";

export default {
    name: 'StoreAccommodationAttribute',
    components: {XSelect, XButtonIcon, XInput, XModal, XButtonSubmit, XButtonCancel},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        record: {
            default: null
        }
    },
    data() {
        return {
            title: null,
            loading: false,
            resource: 'store/accommodation_attributes',
            errors: {},
            form: {},
            countries: [],
            identity_document_types: [],
        }
    },
    created() {
        this.initTables();
        this.initForm();
    },
    methods: {
        async initTables() {
            await this.$http.get(`/${this.resource}/init_tables`)
                .then(response => {
                    this.countries = response.data.countries
                    this.identity_document_types = response.data.identity_document_types
                }).catch(error => {
                    console.log(error)
                })
        },
        initForm() {
            this.title = '';
            this.errors = {};
            this.form = {
                id: null,
                attribute_4000: {
                    code: '4000',
                    value: null,
                    name: 'País de emisión del pasaporte'
                },
                attribute_4001: {
                    code: '4001',
                    value: null,
                    name: 'País de residencia'
                },
                attribute_4007: {
                    code: '4007',
                    value: null,
                    name: 'Nombres y apellidos'
                },
                attribute_4008: {
                    code: '4008',
                    value: '7',
                    name: 'Tipo documento de identidad'
                },
                attribute_4009: {
                    code: '4009',
                    value: null,
                    name: 'Nro. documento de identidad'
                },
                attribute_4002: {
                    code: '4002',
                    value: moment().format('YYYY-MM-DD'),
                    name: 'F.Ingreso al país'
                },
                attribute_4003: {
                    code: '4003',
                    value: moment().format('YYYY-MM-DD'),
                    name: 'F.Ingreso al Establecimiento'
                },
                attribute_4004: {
                    code: '4004',
                    value: moment().format('YYYY-MM-DD'),
                    name: 'F.Salida al Establecimiento'
                },
                attribute_4005: {
                    code: '4005',
                    value: 1,
                    name: 'Nro. Días Permanencia'
                },
                attribute_4006: {
                    code: '4006',
                    value: moment().format('YYYY-MM-DD'),
                    name: 'Fecha de consumo'
                },
            }
        },
        async handleOpen() {
            this.initForm();
            this.title = 'Información del huésped'
            this.form = Object.assign({}, this.form, this.record);
        },
        async onSubmit() {
            if (this.form.attribute_4000.value === null) {
                this.$message.error('El país de emisión del pasaporte es requerido')
                return false
            }
            if (this.form.attribute_4001.value === null) {
                this.$message.error('El país de residencia es requerido')
                return false
            }
            if (this.form.attribute_4007.value === null) {
                this.$message.error('Los nombre y apellidos es requerido')
                return false
            }
            if (this.form.attribute_4009.value === null) {
                this.$message.error('El nro. de documento de identidad es requerido')
                return false
            }
            if (this.form.attribute_4003.value > this.form.attribute_4004.value) {
                this.$message.error('La fecha de salida no puede ser menor a la fecha de ingreso al establecimiento')
                return false
            }

            this.$emit('success', this.form)
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        }
    }
}
</script>
